import styles from "./settingInnerLogs.module.scss";
import React, { useCallback, useEffect, useState } from 'react';
//*import { Link } from "react-router-dom";
//*import iconincoming from "../../../styles/images/iconincoming.svg";
//*import iconoutgoing from "../../../styles/images/iconoutgoing.svg";
import { Dropdown, Slider, Modal, Menu, Progress, Switch, Checkbox } from "antd";
// import { URCheckBox } from "../../../maincomponents/checkbox";
// import { URButton } from "../../../maincomponents/button";
import { URButton } from "../../../../shared/widgets/button";
//*import Password from "antd/lib/input/Password";
//*import { useHistory } from "react-router-dom";
//import { chatSDK } from "unifiedring-sdk";
//*import Item from "antd/lib/list/Item";
import { useSelector } from "react-redux";
import { initialStateModel, LoginState, profileDetails } from "../../../../models/model";
import store from "../../../../context/store/store";
import { SoundMeter } from "./soundMeter";
import AudioPlayer from 'react-h5-audio-player';
// import sound from "./Media/audio.mp3";
import sound2 from "./Media/audio1.mp3";
import _ from "lodash";
import { updateDirectNumber } from "../../../../base/callService/callsApiService";
declare global {
  interface Window {
    audioContext: any;
    stream: any;
    soundMeter: any;
  }
}

type settingsState = {
  defaultDirectNumber: any;
}

type audioSetting = {
  decibelValue: number;
  decibelSpeaker: number;
  audioInput: any[];
  audioOutput: any[];
  enableMic: boolean;
  audioStream: any;
  analyser: any;
  microphone: string;
  audioContext: AudioContext | null;
  meter: number;
  currdeviceid: string | null;
  deviceChanged: boolean;
  currdevicespeaker: string;
}

type settingsProps = {
  profileData: any;
  emergencyAddressDataProps: any;
}

export default function SettingInnerLogs({ profileData, emergencyAddressDataProps }: settingsProps) {
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  // let { defaultCallerID, isdefaultCallerID }: profileDetails = useSelector((state: any) => state.profileReducer);
  let { userdetails } = loginDetails, meterRefresh: any;
  const [settingsStateValues, setsettingsStateValues] = useState<settingsState>({
    defaultDirectNumber: ''
  
  });
  
  const [audioSetting, setaudioSetting] = useState<audioSetting>({
    decibelValue: 0,
    decibelSpeaker: 0,
    enableMic: false,
    audioStream: null,
    analyser: null,
    microphone: "",
    audioContext: null,
    meter: 0,
    currdeviceid: "",
    audioInput: [],
    audioOutput: [],
    deviceChanged: false, currdevicespeaker: ""
  });
  const [testSpeaker, settestSpeaker] = useState<{ test: boolean, speakVol: number }>({ test: false, speakVol: 20 });
  let AudioElement: any = document.querySelector('.speakerAudio > audio');
  let direct_number:any =  store.getState().directNumberDetail?.list ||[];

  useEffect(() => {
    getDeviceList();
  }, []);


  const systemOutputDefault = (
    <>
      <div className={styles.autoTranslateLangs}>
        {/* <div className={styles.searchBox}><URInput placeHolder='Search' className='searchBoxlanglist'/></div> */}
        {/* <ul className={`scroller ${styles.langList}`}>
          <li className={styles.selected}><span className="icon_tick"></span> System Default Device</li>
          <li><span className="icon_tick"></span> Realtek Digital</li>
          <li><span className="icon_tick"></span> 3 Sony Microphone Device</li>
        </ul> */}
        <ul className={`scroller ${styles.langList}`}>
          {audioSetting.audioOutput && audioSetting.audioOutput.map((ele: any, i: number) => {
            return <li onClick={() => mediaSpeakerChange(ele.deviceId, audioSetting)}
              key={i + 10}><span className="icon_tick"></span>{ele.label}</li>
          })}
        </ul>
      </div>
    </>
  );

  const systemInputMic = (
    <>
      <div className={styles.autoTranslateLangs}>
        <ul className={`scroller ${styles.langList}`}>
          {audioSetting.audioInput && audioSetting.audioInput.map((ele: any, i: number) => {
            return <li onClick={() => mediaDeviceChange(ele.deviceId, audioSetting)}
              key={i + 10}><span className="icon_tick"></span>{ele.label}</li>
          })}
        </ul>
      </div>
    </>
  );

  const Direct_Number = (
    <Menu className="yournumbers">

      {direct_number.length > 0 ? direct_number.map((elem: any, index: number) => {
        return (
          <Menu.Item key={index} onClick={() => getDirectNumber(elem.external_number)}>
            <div className="listnumbersec">
               {settingsStateValues?.defaultDirectNumber===elem?.external_number&& <span className="icon_tick"></span>}
                  <p>{elem?.external_number}</p>
                </div>
          </Menu.Item>
        );
      })
        :
        <Menu.Item >No Data Found</Menu.Item>}
    </Menu>
 );

  const getDirectNumber = (directNumber: string) => {
    updateDirectNumber(directNumber);
    setsettingsStateValues({ ...settingsStateValues, defaultDirectNumber: directNumber });

  };
  useEffect(() => {
    setsettingsStateValues({ ...settingsStateValues, defaultDirectNumber: findDefault?.external_number });}, []);

  const findDefault=  direct_number?.find((num:any) => {return ( num?.is_default === 1 )})||direct_number[0];

  // AUDIO SETTINGS FOR MICHROPHONE
  const getDeviceList = () => {
    let currentDeviceId: string | null = localStorage.getItem("deviceid");
    navigator.mediaDevices.enumerateDevices()
      .then(async function (devices) {
        const devicesListAudioInput: Array<any> = [];
        const devicesListAudioOutput: Array<any> = [];
        await devices.forEach(function (device) {
          if (device.deviceId !== "default" && device.deviceId !== "communications") {
            if (device.kind === "audioinput") {

              devicesListAudioInput.push({ deviceId: device.deviceId, label: device.label });
            }
            if (device.kind === "audiooutput") {
              devicesListAudioOutput.push({ deviceId: device.deviceId, label: device.label });
            }
          }
        });
        setaudioSetting({
          ...audioSetting, audioInput: devicesListAudioInput, audioOutput: devicesListAudioOutput, currdeviceid: currentDeviceId
        });

      })
      .catch(function (err: Error) {

      });
  };

  const testMicrophone = useCallback((audioArgs: audioSetting) => {
    window.AudioContext = window.AudioContext || window?.webkitAudioContext;
    window.audioContext = new AudioContext();

    if (audioArgs.currdeviceid) {
      navigator.mediaDevices
        .getUserMedia({ audio: { deviceId: audioArgs.currdeviceid } })
        .then((stream: any) => handleSuccess(stream, audioArgs))
        .catch((err: Error) => handleError(err));
    } else {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((stream: any) => handleSuccess(stream, audioArgs))
        .catch((err: Error) => handleError(err));
    }
  }, [audioSetting.enableMic, audioSetting.decibelValue]);

  const playSpeaker = (test: boolean, eve?: any) => {

    settestSpeaker({ test: test, speakVol: eve | 20 });

    if (test) {
      AudioElement?.play();
    } else {
      AudioElement?.pause();
    }
  };

  const handleSuccess = (stream: any, audioArgs: audioSetting) => {
    window.stream = stream;
    const soundMeter = window.soundMeter = new SoundMeter(window.audioContext);

    if (!audioArgs.enableMic) {
      soundMeter.connectToSource(stream, (e: any) => {
        if (e) {
          alert(e);
          return;
        }
        meterRefresh = setInterval(() => {
          setaudioSetting({
            ...audioArgs, enableMic: true, meter: meterRefresh, decibelValue: soundMeter.instant
          });
        }, 200);
      });
    } else {
      const clearvalue = audioArgs.meter;
      clearInterval(clearvalue);
      setaudioSetting({ ...audioArgs, enableMic: false, meter: 0, decibelValue: (soundMeter.instant * 100) });
      window.stream.getTracks().forEach((track: any) => track.stop());
      window.soundMeter.stop();
    }
  };

  const handleError = (error: Error) => {

    setaudioSetting({ ...audioSetting, enableMic: false });
    window.stream = undefined;
  };

  const mediaDeviceChange = useCallback((selectedId: string, audioArgs: audioSetting) => {
    let microlabel: any = _.find(audioArgs?.audioInput, function (o) { return o.deviceId === selectedId; });

    if (audioArgs.meter) {
      const clearvalue = audioArgs.meter;
      clearInterval(clearvalue);
      setaudioSetting({
        ...audioArgs, enableMic: false, meter: 0, decibelValue: 0, currdeviceid: selectedId, deviceChanged: true, microphone: microlabel?.label
      });
      window.stream.getTracks().forEach((track: any) => track.stop());
      window.soundMeter.stop();
    } else setaudioSetting({ ...audioArgs, currdeviceid: selectedId, deviceChanged: true, microphone: microlabel?.label });
    window.stream = undefined;
  }, []);
  const mediaSpeakerChange = useCallback((selectedId: string, audioArgs: audioSetting) => {
    let microlabel: any = _.find(audioArgs?.audioOutput, function (o) { return o.deviceId === selectedId; });

    setaudioSetting({
      ...audioArgs, currdevicespeaker: microlabel?.label
    });


  }, []);

  
  const [isModalVisible4, setIsModalVisible4] = useState(false);
  const showModal4 = () => { setIsModalVisible4(true); };
  const handleOk4 = () => { setIsModalVisible4(false); };
  const handleCancel4 = () => { setIsModalVisible4(false); };

  const plainOptions = ['Read', 'Write'];
  return (
    <>
      <div className={styles.mainInnerConSec}>
        <div className={styles.userprofileformCon}>
          <div className={`${styles.formGroup} `}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}>Default Number</label>
              <div className={styles.five}>
                <div className={styles.shareSelect}>
                  <Dropdown overlay={Direct_Number} placement="bottomRight" trigger={['click']}>
                    <div className={styles.langSelSec}>
                      <span>{settingsStateValues.defaultDirectNumber ? settingsStateValues.defaultDirectNumber 
                        : `select a Default Number`}</span>
                      <span className="icon_downarrow2"></span>
                    </div>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}></label>
              <p className={`${styles.five} ${styles.changPassTxt}`}>
                <span className={styles.direcrNo}>
                  Direct number to be displayed on your profile page and on Caller ID display of a person you’re calling
                </span></p>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}>Microphone</label>
              <div className={styles.five}>
                <div className={styles.shareSelect}>
                  <Dropdown overlay={systemInputMic} placement="bottomRight" >
                    <div className={styles.langSelSec}>
                      <span>{audioSetting.microphone !== "" ? audioSetting.microphone : "System Default Device"} </span>
                      <span className="icon_downarrow2"></span>
                    </div>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}></label>
              <div className={`${styles.five} ${styles.speakerInputLeve}`}>
                <div className={styles.inpttsxttop}>
                  <span>Input Level</span>
                </div>
                <div className={styles.badgeProgess}>
                  <Progress percent={audioSetting.decibelValue * 250} type="line" steps={10} strokeWidth={5} showInfo={false} />
                  {/* <ul>
                    <li className={styles.progressBadge}></li>
                    <li className={styles.progressBadge}></li>
                    <li className={styles.progressBadge}></li>
                    <li className={`${styles.progressBadge} ${styles.progresslight}`}></li>
                    <li className={`${styles.progressBadge} ${styles.progressregular}`}></li>
                    <li ></li>
                  </ul> */}
                </div>
                <div>
                  <URButton onClick={() => testMicrophone(audioSetting)} className='urButton buttonBlue buttonSm' name='Test' />
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}>Speaker</label>
              <div className={styles.five}>
                <div className={styles.shareSelect}>
                  <Dropdown overlay={systemOutputDefault} placement="bottomRight" >
                    <div className={styles.langSelSec}>
                      <span>{audioSetting.currdevicespeaker !== "" ? audioSetting.currdevicespeaker : "System Default Device"}  </span>
                      <span className="icon_downarrow2"></span>
                    </div>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}></label>
              <div className={`${styles.five} ${styles.speakerInputLeve}`}>
                <div className={styles.inpttsxttop}>
                  <span>Volume</span>
                </div>
                <div className={styles.badgeProgess}>
                  <div className={`customaudioplaySound ${styles.audioplaySound}`}>
                    <span className="icon_Volume" ></span>
                    <Slider defaultValue={0} onChange={(e: any) => playSpeaker(testSpeaker.test, e)} style={{ width: "90px" }} />
                    <span className="icon_Volumemax" ></span>
                  </div>
                </div>
                <div>
                  <URButton onClick={() => playSpeaker(!testSpeaker.test)} className='urButton buttonBlue buttonSm' name='Test' />
                  <AudioPlayer volume={testSpeaker.speakVol * 0.01} className="speakerAudio" style={{ display: "none" }} src={sound2} />
                  {/* <URButton className={styles.editbtn} name='Test' /> */}
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <label className={`${styles.three} ${styles.colformLabel}`}>Notifications</label>
              <div className={`${styles.five} ${styles.alignItemCenter}`}>
                <div className={styles.switchtogglebtn}>
                  <p>Email</p>
                  <label className={styles.switch}>
                    <input type="checkbox" />
                    <span className={`${styles.slider} ${styles.round}`}></span>
                  </label>
                  <p>Mobile</p>
                  <label className={styles.switch}>
                    <input type="checkbox" />
                    <span className={`${styles.slider} ${styles.round}`}></span>
                  </label>
                  {/* <span>Email</span> <Switch />
                      <span>Mobile</span> <Switch />  */}
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    
      <Modal visible={isModalVisible4} title="Microsoft 365 Contacts Service"
        centered
        onOk={handleOk4}
        onCancel={handleCancel4}
        cancelText="Cancel"
        okText="Authorize"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup ">
        <div className={styles.bodyText}>
          <p>Worktual will access your account contacts based on the below selected permissions</p>
          <Checkbox.Group options={plainOptions} defaultValue={['Apple']} />
        </div>
      </Modal>
    </>
  );
};
